/**
 * Custom hook to filter tools based on platform, teacher Khanmigo access,
 * and locale-specific curation.
 *
 * @param {Object} teacherToolsResult - Result of the teacher tools query.
 * @param {Array} favoritedToolsResult - Result of the favorited tools query.
 * @returns {Array} - List of filtered tools.
 */

import {useMemo} from "react";

import {determineToolsList} from "../ai-tools-utils.ts";
import {getFavoritedToolsWithPermission} from "../utils.ts";

import type {getFavoritedTeacherTools_aiGuideFavoritedTeacherTools as TeacherTool} from "./__graphql-types__/getFavoritedTeacherTools.ts";

const useFilteredTools = (
    teacherToolsResult,
    favoritedTeacherTools: TeacherTool[],
    favoritedTeacherToolsStatus,
) => {
    return useMemo(() => {
        if (
            favoritedTeacherToolsStatus !== "success" ||
            teacherToolsResult?.status !== "success"
        ) {
            return [];
        }

        const toolList = determineToolsList(
            teacherToolsResult.data.aiGuideTeacherTools,
        );

        return getFavoritedToolsWithPermission(
            toolList,
            favoritedTeacherTools ?? [],
        );
    }, [
        teacherToolsResult,
        favoritedTeacherTools,
        favoritedTeacherToolsStatus,
    ]);
};

export default useFilteredTools;
